import _enTranslation from "./en.json";
import _enApiTranslation from "./en.api.json";

const translation = {
  ..._enTranslation,
  ..._enApiTranslation,
};

export default translation;
